/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PendoUser } from '../model';
/**
 * PendoApi - axios parameter creator
 * @export
 */
export const PendoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets Pendo config for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendoUser: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/pendo/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PendoApi - functional programming interface
 * @export
 */
export const PendoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PendoApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets Pendo config for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendoUser(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PendoUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendoUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PendoApi - factory interface
 * @export
 */
export const PendoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PendoApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets Pendo config for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendoUser(options?: any): AxiosPromise<PendoUser> {
            return localVarFp.getPendoUser(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PendoApi - object-oriented interface
 * @export
 * @class PendoApi
 * @extends {BaseAPI}
 */
export class PendoApi extends BaseAPI {
    /**
     * 
     * @summary Gets Pendo config for user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PendoApi
     */
    public getPendoUser(options?: any) {
        return PendoApiFp(this.configuration).getPendoUser(options).then((request) => request(this.axios, this.basePath));
    }
}
